import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  FaUser,
  FaEnvelope,
  FaCity,
  FaPhone,
  FaMapMarkerAlt,
  FaIdCard,
  FaUserShield,
} from "react-icons/fa";

const RaiseProfile = () => {
  const [profileData, setProfileData] = useState({
    name: "",
    email: "",
    mobile: "",
    _id: "",
    residenceAddress: "",
    state: "",
    city: "",
    gender: "",
    createdAt: "",
  });

  // Only display data, no editing

  useEffect(() => {
    fetchProfileData();
  }, []);



  // fetch profile data using API call
  const fetchProfileData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/get/raise/ryv/user/profile`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      console.log("Profile Data Response:", response);
      setProfileData(response.data.data);
      // Only display data, no editing
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  };

  const ProfileField = ({ icon: Icon, label, value }) => (
    <div className="mb-4">
      <label className="block text-gray-700 text-sm font-bold mb-2">
        <div className="flex items-center gap-2">
          <Icon className="text-gray-500" />
          {label}
        </div>
      </label>
      <p className="text-gray-700 py-2">{value}</p>
    </div>
  );

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800"> Your Profile</h1>

      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <div className="flex items-center mb-6">
          <div className="w-24 h-24 bg-gray-200 rounded-full overflow-hidden flex items-center justify-center">
            <img
              src={
                profileData.gender === "male"
                  ? "/bg-images/man.png"
                  : "/bg-images/women.png"
              }
              alt="Profile"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="ml-6">
            <h2 className="text-xl font-semibold">{profileData.name}</h2>
            <p className="text-gray-600">{profileData.role}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <ProfileField
              icon={FaUser}
              label="Full Name"
              value={profileData.name}
            />
            <ProfileField
              icon={FaEnvelope}
              label="Email"
              value={profileData.email}
            />
            <ProfileField
              icon={FaPhone}
              label="Phone"
              value={profileData.phoneNo}
            />
            <ProfileField
              icon={FaIdCard}
              label="User ID"
              value={profileData._id}
            />
          </div>
          <div>
            <ProfileField
              icon={FaMapMarkerAlt}
              label="Residence Address"
              value={profileData.residenceAddress}
            />
            <ProfileField
              icon={FaCity}
              label="City"
              value={profileData.city}
            />
            <ProfileField
              icon={FaMapMarkerAlt}
              label="State"
              value={profileData.state}
            />

            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                <div className="flex items-center gap-2">
                  <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  Join Date
                </div>
              </label>
              <p className="text-gray-700 py-2">
                {profileData.createdAt
                  ? new Date(profileData.createdAt).toLocaleDateString("en-US", {
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                  })
                  : ""}
              </p>
            </div>
          </div>
        </div>
        {/* No editing or submit button */}
      </div>
      {/* No form, just display data */}
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default RaiseProfile;
